import { MessageSquare, RefreshCw, Stethoscope } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import ChatPanel from "@/components/editor/ChatPanel";
import { useEditor } from "@/components/editor/useEditorState";
import RegenPanel from "./RegenPanel";
import FixPanel from "./FixPanel";

const MODES = [["chat", "Chat", MessageSquare], ["regen", "Rigenera", RefreshCw], ["fix", "Correggi", Stethoscope]];

export default function AiPanel() {
  const { ui, setUi } = useEditor();
  const mode = ui.aiMode || "chat";
  return (
    <div className="h-full flex flex-col min-h-0" data-testid="ai-panel">
      <div className="shrink-0 grid grid-cols-3 gap-1 border-b bg-slate-50 p-1.5">
        {MODES.map(([k, l, Icon]) => (
          <button key={k} onClick={() => setUi({ aiMode: k })} data-testid={`ai-mode-${k}`}
            className={`inline-flex items-center justify-center gap-1 rounded-md py-1.5 text-[11.5px] font-medium transition-colors ${mode === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}>
            <Icon size={12} />{l}
          </button>
        ))}
      </div>
      <div className="flex-1 min-h-0">
        {mode === "chat" && <ChatPanel />}
        {mode === "regen" && <ScrollArea className="h-full"><RegenPanel /></ScrollArea>}
        {mode === "fix" && <ScrollArea className="h-full"><FixPanel /></ScrollArea>}
      </div>
    </div>
  );
}
